document.addEventListener('DOMContentLoaded', () => {
  const anchors = document.querySelectorAll('a')

  const filteredAnchors = [...anchors].filter(anchor => anchor.hash)

  filteredAnchors.forEach(anchor => {
    anchor.addEventListener('click', event => {
      const hash = event.currentTarget.hash

      history.pushState(null, null, hash)
    })
  })
})
